import React from 'react';

export const WeBuyPropertyTypes: React.FC = () => {
  const propertyTypes = [
    {
      title: 'Small Multi-Family',
      description: '2-4 unit properties, duplexes, triplexes, and fourplexes',
      icon: 'ri-home-4-line'
    },
    {
      title: 'Mid-Size Buildings',
      description: '5-20 unit apartment buildings and complexes',
      icon: 'ri-building-line'
    },
    {
      title: 'Large Complexes',
      description: '20+ unit apartment communities and high-rises',
      icon: 'ri-community-line'
    },
    {
      title: 'Mixed-Use Properties',
      description: 'Buildings with residential and commercial spaces',
      icon: 'ri-store-3-line'
    },
    {
      title: 'Distressed Properties',
      description: 'Buildings needing repairs, renovations, or updates',
      icon: 'ri-hammer-line'
    },
    {
      title: 'Occupied Buildings',
      description: 'Properties with existing tenants and active leases',
      icon: 'ri-group-line'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">Properties We Buy</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We purchase all types of multi-family properties in any condition
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {propertyTypes.map((type, index) => (
            <div 
              key={index}
              className="bg-gray-50 rounded-lg p-8 hover:shadow-lg transition-all duration-300 border-2 border-transparent hover:border-orange-500"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-orange-100 text-orange-500 rounded-lg mb-6">
                <i className={`${type.icon} text-3xl`}></i>
              </div>
              <h3 className="text-2xl font-bold mb-4">{type.title}</h3>
              <p className="text-gray-600 leading-relaxed">{type.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
